import { createAction } from '@reduxjs/toolkit';

import { TradeRequestItem, TradeRequestQueryParams } from 'data/models/TradeRequest';
import { errorHandler } from 'services/axiosService';
import { fetchTradeRequests } from 'data/data-layer/tradeRequests';
import { AppThunkDispatch } from '../store';

export const SET_TRADE_REQUESTS = 'SET_TRADE_REQUESTS';
export const SET_TRADE_REQUESTS_IS_LOADING = 'SET_TRADE_REQUESTS_IS_LOADING';
export const RESET_TRADE_REQUESTS = 'RESET_TRADE_REQUESTS';

export const setTradeRequests = createAction<TradeRequestItem[]>(SET_TRADE_REQUESTS);
export const setTradeRequestsIsLoading = createAction<boolean>(SET_TRADE_REQUESTS_IS_LOADING);
export const resetTradeRequestsAction = createAction<boolean>(RESET_TRADE_REQUESTS);

export const getTradeRequests =
  (params?: TradeRequestQueryParams) =>
  async (dispatch: AppThunkDispatch): Promise<TradeRequestItem[]> => {
    dispatch(setTradeRequestsIsLoading(true));
    try {
      const response = await fetchTradeRequests(params);
      dispatch(setTradeRequests(response.items));
      return response.items;
    } catch (e) {
      await errorHandler(dispatch, 'API Error: Failed fetching trade requests')(e);
      dispatch(setTradeRequests([]));
      return [];
    } finally {
      dispatch(setTradeRequestsIsLoading(false));
    }
  };

export const resetTradeRequests =
  () =>
  async (dispatch: AppThunkDispatch): Promise<void> => {
    await dispatch(setTradeRequestsIsLoading(true));
    await dispatch(resetTradeRequestsAction(true));
  };
